import { MODAL_TYPES } from '../../../common/constants'

const callbacks = new Map<string, () => void>()

export const setDeleteCallback = (id: string, fn: () => void) => callbacks.set(id, fn)

export const getDeleteCallback = (id: string) => callbacks.get(id)

export const clearDeleteCallback = (id: string) => callbacks.delete(id)

export interface DeleteModalProps {
    callbackId: string
    id?: number
    selectedRowsIds?: number[]
}

//  Sets up delete callback for delete (single/multiple) operations inside lists & views
export const setupDeleteCallback = (modalType: string, modalProps: DeleteModalProps, deleteFn: (param: unknown) => void) => {
    if (modalType !== MODAL_TYPES.DELETE_MODAL) return

    const { callbackId, id, selectedRowsIds } = modalProps

    if (!callbackId) return

    if (id !== undefined) {
        setDeleteCallback(callbackId, () => deleteFn(id))
    } else {
        setDeleteCallback(callbackId, () => deleteFn(selectedRowsIds))
    }
}
